<template>
  <v-dialog v-model="dialog" width="700px">
    <v-card>
      <v-card-title class="accent white--text darken-2"
        >تسجيل طالب جديد</v-card-title
      >
      <v-container class="te">
        <v-row>
          <div>
            <v-card flat width="700px">
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="6" sm="6">
                        <v-text-field
                          v-model="student.name"
                          label="الاسم"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="student.fatherName"
                          label="اسم الأب"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="student.birthdate"
                          :rules="nameRules"
                          type="date"
                          label="تاريخ الميلاد"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="student.mobile"
                          label="الموبايل"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mb-2">
                      <v-col cols="12">
                        <v-autocomplete
                          ref="classes"
                          v-model="student.classId"
                          :items="classes"
                          placeholder="اختر الشعبة المراد تسجيل الطالب بها"
                          required
                          item-text="name"
                          item-value="id"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="student.registrationFee"
                          type="number"
                          label="القسط الكامل"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="student.numberOfInstallments"
                          type="number"
                          label="عدد الأقساط"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                       <v-row class="mb-2">
                    <v-col cols="12">
                      <v-text-field
                        label="تاريخ اول دفعة "
                        value="1/1/001"
                        type="date"
                        v-model="student.firstInstallmentDate"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="student.fingerPrintNum"
                          label="رقم البصمة"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="student.userName"
                          :rules="userNameRules"
                          label="اسم المستخدم"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="student.password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :rules="passwordRules"
                          :type="show1 ? 'text' : 'password'"
                          label="كلمة المرور"
                          @click:append="show1 = !show1"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </div>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">الغاء</v-btn>
        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="addStudent"
          :loading="isClick"
          >حفظ</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//new
import { APIService } from "../../services/apiServices";
const apiService = new APIService();
export default {
  // name: "AddSubject",
  props: {
    show: Boolean,
  },
  data: () => ({
    valid: true,
    addEnable: true,
    isClick: false,
    dialog: false,
    show1: false,
    classes: [],
    student: {
      id: 0,
      name: "",
      mobile: "",
      birthdate: "",
      userName: "",
      password: "",
      classId: 0,
      registrationFee: 0,
      numberOfInstallments: 0,
      firstInstallmentDate:"",
      fingerPrintNum:""
    },

    nameRules: [
      (v) => !!v || "يجب ادخال الاسم",
      (v) => (v && v.length <= 255) || "يجب أن يكون الاسم أقل من 255 حرف",
    ],

    userNameRules: [
      (v) => !!v || "يجب ادخال اسم المستخدم",
      (v) => (v && v.length <= 255) || "يجب أن يكون الاسم أقل من 255 حرف",
    ],
    passwordRules: [
      (v) => !!v || "يجب ادخال كلمة المرور",
      (v) => (v && v.length <= 255) || "يجب أن يكون الاسم أقل من 255 حرف",
    ],


   
  }),
  methods: {
    addStudent() {
      if (this.$refs.form.validate()) {
        this.isClick = true;
        this.addEnable = true;
        setTimeout(() => {
          apiService
            .addStudent(this.student)
            .then((response) => {
              if (response != "") {
                this.student = {
                  id: 0,
                  name: "",
                  mobile: "",
                  birthdate: "",
                  userName: "",
                  password: "",
                  classId: 0,
                  registrationFee: 0,
                  numberOfInstallments: 0,
                  fingerPrintNum:""
                };

                this.dialog = false;
                this.$emit("studentAdded");
              } else {
                this.isClick = false;
              }
            })
            .catch((error) => {
              this.error = "حدث خطأ ";
              alert(error);
              this.failed();
            })
            .finally(() => {
              this.isClick = false;
            });
        }, 3000);

        //this.dialog = false;
      }
    },

    getClasses() {
      apiService
        .getClasses()
        .then((response) => {
          this.classes = response.classes;
        })
        .catch((error) => {
          this.error = "Unknown Error. Please check details and try again.";
          alert(error);
          this.failed();
        });
    },
  },

  watch: {
    show(val) {
      this.dialog = val;
    },

    dialog(val) {
      this.$emit("update:show", val);
      const that = this;
      setTimeout(() => {
        that.$refs.form.resetValidation();
      }, 300);
    },
  },

  created() {
    this.getClasses();
  },
};
</script>
